
<div
    class="agpr-brandIdentityCard"
    [class]="{
        'agpr-brandIdentityCard--withBorder': showBorder
    }"
>
    @if (_brand?.id || _brand?.id === 0) {
        <div class="agpr-brandIdentityCard-header">
            @if (_brand?.logo?.source && !logoLoadingError) {
                <div class="agpr-brandIdentityCard-logo">
                    <img
                        [src]="_brand.logo?.source"
                        [alt]="_brand.name"
                        (error)="logoLoadingError = true"
                    />
                </div>
            } @else {
                <div
                    class="agpr-brandIdentityCard-logo"
                    [style.background-color]="_brand.logoPlaceholderColor"
                >
                    <span aria-hidden="true"> {{ _brand.logoPlaceholder }} </span>
                </div>
            }
            <div
                class="agpr-brandIdentityCard-brandName"
                [agprTooltip]="_brand.name"
                tooltipPosition="top"
            >
                {{ _brand.name }}
            </div>
        </div>
    } @else {
        <div class="agpr-brandIdentityCard-header">
            <div
                class="agpr-brandIdentityCard-logo"
                [style.background-color]="_brand.logoPlaceholderColor"
            >
                <span aria-hidden="true"> {{ _brand.logoPlaceholder }} </span>
            </div>
            <agpr-text-input
                [id]="id + '_brandIdentityNameInput'"
                class="agpr-brandIdentityCard-brandNameInput"
                [ariaLabel]="'Common.brandIdentityCard.nameInput.placeholder'"
                [placeholder]="'Common.brandIdentityCard.nameInput.placeholder' | localize"
                [(ngModel)]="_brand.name"
                (ngModelChange)="onBrandNameChanged()"
                [maxLength]="256"
                [bottomMargin]="false"
            ></agpr-text-input>
            <agpr-button
                [id]="id + '_createBrandIdentity'"
                class="agpr-brandIdentityCard-createButton"
                [style]="buttonTypes.primaryB"
                label="Common.brandIdentityCard.button.create"
                [tooltip]="!_brand.name ? 'Common.brandIdentityCard.button.create.disabledTooltip' : ''"
                (click)="create()"
                [disabled]="!_brand.name || aiGenerating"
            ></agpr-button>
        </div>
        <div
            class="agpr-brandIdentityCard-quickCreate"
            [class]="{
                'agpr-brandIdentityCard-quickCreate--active': _brand.name
            }"
        >
            @if (aiGenerating) {
                <div class="agpr-brandIdentityCard-quickCreate-loading">
                    <div class="agpr-brandIdentityCard-quickCreate-loadingTitle">
                        <span
                            class="agpr-brandIdentityCard-quickCreate-loadingSpinner"
                            [agprLoading]="true"
                            [agprInlineLoadingIndicator]="true"
                            [loadingSmallIndicator]="true"
                        ></span>
                        {{ 'Common.brandIdentityCard.quickCreate.loading.title' | localize}}
                    </div>
                    <div class="agpr-brandIdentityCard-quickCreate-loadingDetail">
                        {{ 'Common.brandIdentityCard.quickCreate.loading.details' | localize}}
                    </div>
                </div>
            } @else {
                <div class="agpr-brandIdentityCard-quickCreate-prompt">
                    <span>{{ 'Common.brandIdentityCard.quickCreate.message' | localize}}</span>
                    <agpr-button
                        [id]="id + '_createBrandIdentity'"
                        class="agpr-brandIdentityCard-quickCreateButton"
                        [style]="buttonTypes.primary"
                        label="Common.brandIdentityCard.button.create"
                        icon="fa-kit-duotone fa-agpr-ai-generic"
                        [tooltip]="!_brand.name ? 'Common.brandIdentityCard.button.create.disabledTooltip' : ''"
                        (click)="aiCreate()"
                        [disabled]="!_brand.name"
                    ></agpr-button>
                </div>
            }
        </div>
    }
</div>



